import React, { useMemo } from 'react';
import { fc, getWeeklyRecap } from '../../utils';

const fmt = (d) => d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });

// "Your week" card: shown from Monday until the user dismisses it, then
// stays away until the next week finishes.
export function WeeklyRecapCard({ state, updateState, varBudget }) {
  const r = useMemo(() => getWeeklyRecap(state, new Date(), varBudget), [state, varBudget]);
  if (!r || state.recapSeen?.[r.weekKey]) return null;

  const dismiss = () => {
    const rs = { ...(state.recapSeen || {}), [r.weekKey]: true };
    // Keep the map small: drop old weekly keys beyond the last 8.
    const wk = Object.keys(rs).filter((k) => k.startsWith('wk_')).sort();
    wk.slice(0, Math.max(0, wk.length - 8)).forEach((k) => delete rs[k]);
    updateState({ recapSeen: rs });
  };

  const up = r.change != null && r.change > 0;
  const rows = [
    r.income > 0 && { l: '💰 Money in', v: fc(r.income), c: 'var(--grn)' },
    r.saved > 0 && { l: '💵 Saved', v: fc(r.saved), c: 'var(--grn)' },
    r.topCat && { l: 'Top category', v: `${r.topCat.name} · ${fc(r.topCat.amt)}` },
    r.topPlace && { l: 'Biggest spot', v: `${r.topPlace.name} · ${fc(r.topPlace.amt)}` },
    r.noSpend > 0 && { l: '🛑 No-spend days', v: r.noSpend },
  ].filter(Boolean);

  return (
    <div className="card cp weekly-recap">
      <div className="wr-head">
        <span>📆 Your week · {fmt(r.start)} – {fmt(r.end)}</span>
        <button className="wr-x" onClick={dismiss} aria-label="Dismiss">✕</button>
      </div>
      <div className="wr-spent">
        <span className="wr-big">{fc(r.spent)}</span>
        <span className="wr-sub">
          spent{r.weekBudget > 0 && <> of {fc(r.weekBudget)}</>}
          {r.change != null && (
            <span style={{ color: up ? 'var(--red)' : 'var(--grn)', marginLeft: 6 }}>
              {up ? '▲' : '▼'} {Math.abs(Math.round(r.change * 100))}% vs week before
            </span>
          )}
        </span>
      </div>
      {rows.map((row) => (
        <div key={row.l} className="wr-row">
          <span>{row.l}</span>
          <b style={{ color: row.c || 'var(--txt)' }}>{row.v}</b>
        </div>
      ))}
      {(r.wins.length > 0 || r.watch.length > 0) && (
        <div className="wr-notes">
          {r.wins.map((w) => <div key={w} className="wr-win">✓ {w}</div>)}
          {r.watch.map((w) => <div key={w} className="wr-watch">👀 {w}</div>)}
        </div>
      )}
      <button className="btn wr-done" onClick={dismiss}>Got it, new week 💪</button>
    </div>
  );
}
